module.exports = __webpack_public_path__ + "img/curso-de-administração.7a0040b3.jpg";